import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

export default function ProtectedRoute({ children, requireAdmin = false }) {
  const { user, checked } = useAuth();
  if (!checked) {
    return <div className="min-h-screen flex items-center justify-center text-scu-smoke">Loading…</div>;
  }
  if (!user) return <Navigate to="/login" replace />;
  if (requireAdmin && user.role !== "admin") return <Navigate to="/portal" replace />;
  return children;
}
